import { create } from 'zustand';

type ConnectionErrorModalState = {
  isVisible: boolean;
  show: () => void;
  hide: () => void;
};

export const useConnectionErrorModalStore = create<ConnectionErrorModalState>((set) => ({
  isVisible: false,
  show: () => set({ isVisible: true }),
  hide: () => set({ isVisible: false }),
}));
